export const CONTAINER_DEFAULTS = {
  padding: '20px 25px 20px 25px', // top right bottom left
  margin: '0px 0px 0px 0px', // top right bottom left
  overflow: 'clip',
  plainBorderRadius: '0px 0px 0px 0px',
  cardBorderRadius: '10px 10px 10px 10px',
  plainBoxShadow: 'none',
  cardBoxShadow: '0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814',
};
